import type { FC, ReactNode } from 'react'
import { Provider } from 'react-redux'
import { router } from '#app/routes/router'
import { store } from '#app/store'
import { AppLayout } from '#features/AppLayout'
import { useReactScan } from '#features/DebugSettings/useReactScan'
import { CustomReportDataContext } from '#features/ErrorHandling/CustomReportContext'
import { ShortcutContext } from '#features/Shortcuts/ShortcutContext'
import { ToastContext } from '#features/Toasts/ToastContext'
import { QueuedToasts } from '#features/Toasts/ToastQueue'
import { useCreateToastContext } from '#features/Toasts/useCreateToastContext'
import { useForbiddenRedirector } from '#features/User/useForbiddenRedirector'
import { WelcomeOverlay } from '#features/WelcomeOverlay/WelcomeOverlay'

const ReduxInitializer = () => {
  useReactScan()
  useForbiddenRedirector(router)

  return null
}

export const AppProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const toastContext = useCreateToastContext()

  return (
    <Provider store={store}>
      <ReduxInitializer />

      <ShortcutContext>
        <CustomReportDataContext>
          <ToastContext.Provider value={toastContext}>
            <QueuedToasts placement="bottom" />
            <AppLayout>{children}</AppLayout>
            <WelcomeOverlay />
          </ToastContext.Provider>
        </CustomReportDataContext>
      </ShortcutContext>
    </Provider>
  )
}
